import { useOperationGetList } from 'api/requests';
import { OperationsFilterParams } from 'api/types/data/operation';
import { useQueryListData } from 'hooks';
import { generatePath, ROUTES } from 'libs/navigation';
import { TableSetRowHref } from 'libs/ui';

import { OperationsListItem, SortField } from '../types';

const LIMIT = 50;

export const useOperations = () => {
  const {
    list: operations,
    rowCount,
    loading,
    setFilter,
    sort,
    page,
    filter,
    onPaginationChange,
    onSortChange,
  } = useQueryListData<OperationsListItem, SortField, OperationsFilterParams>(
    useOperationGetList,
    {
      limit: LIMIT,
      filterParams: [
        'orderStatuses',
        'traderIds',
        'executionTimestamps',
        'orderEndTimestamps',
        'search',
      ],
      filterParsers: {
        search: (value) => value,
      },
    }
  );

  const setRowHref: TableSetRowHref<OperationsListItem> = (operation) =>
    generatePath(ROUTES.operations.operation.fullPath, {
      operationId: operation.id,
    });

  // GMT+5 (Алматы)
  // TODO: Feature request to get broker timezone offset from API
  const brokerTimezoneOffset = 18000;

  return {
    operations,
    rowCount,
    loading: loading && !operations.length,
    sort,
    page,
    filter,
    limit: LIMIT,
    brokerTimezoneOffset,
    setRowHref,
    setFilter,
    onPaginationChange,
    onSortChange,
  };
};
